import { createSlice } from "@reduxjs/toolkit";
import { ChatbotMessageData, ChatHistoryData, ChatHistoryConversation } from "./Types";

type initialStateType = {
  messageResponse: ChatbotMessageData | null;
  status: {
    loading: boolean;
    error: boolean;
    errorMessage: string | null;
  };
  chatHistory: ChatHistoryData | null;
  chatHistoryStatus: {
    loading: boolean;
    error: boolean;
    errorMessage: string | null;
  };
  individualChatHistory: ChatHistoryConversation[] | null;
  individualChatHistoryStatus: {
    loading: boolean;
    error: boolean;
    errorMessage: string | null;
  };
};

var initialState: initialStateType = {
  messageResponse: null,
  status: {
    loading: false,
    error: false,
    errorMessage: null,
  },
  chatHistory: null,
  chatHistoryStatus: {
    loading: false,
    error: false,
    errorMessage: null,
  },
  individualChatHistory: null,
  individualChatHistoryStatus: {
    loading: false,
    error: false,
    errorMessage: null,
  },
};

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState: initialState,
  reducers: {
    setMessageResponse: (state, action) => {
      state.messageResponse = action.payload;
    },
    setLoading: (state, action) => {
      state.status.loading = action.payload;
    },
    setError: (state, action) => {
      state.status.error = action.payload.error;
      state.status.errorMessage = action.payload.errorMessage || null;
    },
    resetChatbotState: (state) => {
      state.messageResponse = null;
      state.status.error = false;
      state.status.errorMessage = null;
    },
    setChatHistory: (state, action) => {
      state.chatHistory = action.payload;
    },
    setChatHistoryLoading: (state, action) => {
      state.chatHistoryStatus.loading = action.payload;
    },
    setChatHistoryError: (state, action) => {
      state.chatHistoryStatus.error = action.payload.error;
      state.chatHistoryStatus.errorMessage = action.payload.errorMessage || null;
    },
    setIndividualChatHistory: (state, action) => {
      state.individualChatHistory = action.payload;
    },
    setIndividualChatHistoryLoading: (state, action) => {
      state.individualChatHistoryStatus.loading = action.payload;
    },
    setIndividualChatHistoryError: (state, action) => {
      state.individualChatHistoryStatus.error = action.payload.error;
      state.individualChatHistoryStatus.errorMessage = action.payload.errorMessage || null;
    },
  },
});

export const chatbotSliceReducer = chatbotSlice.reducer;
export const chatbotSliceAction = chatbotSlice.actions;
